// extracted by mini-css-extract-plugin
export default {"infoCardContainer":"InfoCardVideo_infoCardContainer__u3QEJ","videoContainer":"InfoCardVideo_videoContainer__ECdqV","textContainer":"InfoCardVideo_textContainer__MAKxJ"};